import { MapPin, Truck, Globe } from "lucide-react";
import CTA from "../components/CTA";
export default function Service() {
  const services = [
    {
      title: "Regional Delivery",
      desc: "Jopo Delivery enables quick movement of parcels across locations within a single city.",
      icon: <MapPin size={28} />,
    },
    {
      title: "Inter-Regional Delivery",
      desc: "Jopo Delivery connects cities using vans, trucks, and coordinated logistics routes.",
      icon: <Truck size={28} />,
    },
    {
      title: "International Delivery",
      desc: "Jopo Delivery facilitates cross-border logistics through partnerships with global and regional carriers.",
      icon: <Globe size={28} />,
    },
  ];

  return (
    <div className="bg-gray-50">
      {/* HERO */}
      <div className="bg-white py-16 px-10 text-center">
        <h1 className="text-3xl md:text-4xl font-bold text-gray-800">
          Our <span className="text-orange-500">Services</span>
        </h1>

        <p className="mt-4 max-w-2xl mx-auto text-gray-600">
          We provide fast, reliable, and scalable delivery solutions tailored
          for individuals and businesses.
        </p>
      </div>

      {/* SERVICES */}
      <div className="py-16 px-10">
        <div className="flex items-center justify-center mb-12">
          <div className="w-24 h-1 bg-orange-400"></div>

          <h2 className="mx-4 text-2xl font-bold text-gray-800">
            What We Offer
          </h2>

          <div className="w-24 h-1 bg-orange-400"></div>
        </div>

        {/* CARDS */}
        <div className="grid md:grid-cols-3 gap-6">
          {services.map((service, i) => (
            <div
              key={i}
              className="p-6 bg-white shadow-md rounded-lg hover:shadow-lg transition"
            >
              {/* ICON */}
              <div className="w-14 h-14 mb-4 bg-orange-100 text-orange-500 flex items-center justify-center rounded-full">
                {service.icon}
              </div>

              {/* TITLE */}
              <h3 className="text-lg font-semibold text-gray-800 mb-2">
                {service.title}
              </h3>

              {/* DESC */}
              <p className="text-gray-500 text-sm">{service.desc}</p>
            </div>
          ))}
        </div>
      </div>

      {/* VALUE SECTION */}
      <div className="py-16 px-10 bg-white">
        <div className="grid md:grid-cols-3 gap-8 text-center">
          <div>
            <h3 className="text-xl font-bold text-orange-500">Fast</h3>
            <p className="text-gray-600 mt-2">
              Same-day and scheduled deliveries to meet your needs.
            </p>
          </div>

          <div>
            <h3 className="text-xl font-bold text-orange-500">Reliable</h3>
            <p className="text-gray-600 mt-2">
              Trusted riders and structured logistics network.
            </p>
          </div>

          <div>
            <h3 className="text-xl font-bold text-orange-500">Secure</h3>
            <p className="text-gray-600 mt-2">
              Safe handling and secure payment systems.
            </p>
          </div>
        </div>
      </div>

      {/* CTA */}
      <CTA />
    </div>
  );
}
